import { HomeIcon, UsersIcon, CalendarIcon, ClipboardCheckIcon } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/utils";
import { useCalendar } from "@/contexts/CalendarContext";
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon, requiresRole: ['admin', 'super_admin'] },
  { name: 'Contracts', href: '/contracts', icon: UsersIcon },
  { name: 'Calendar', href: '/calendar', icon: CalendarIcon },
  { name: 'Pending', href: '/pending', icon: ClipboardCheckIcon, requiresRole: ['admin', 'super_admin'] },
];

export function Sidebar() {
  const { refreshAvailability } = useCalendar();
  const location = useLocation();
  const { user } = useAuth();

  // When the location changes to calendar, refresh the availability
  useEffect(() => {
    if (location.pathname === '/calendar') {
      refreshAvailability();
    }
  }, [location.pathname, refreshAvailability]);

  // Filter navigation items based on user role
  const filteredNavigation = navigation.filter(item => {
    // If the item has role requirements, check if user has the required role
    if (item.requiresRole) {
      return user?.role && item.requiresRole.includes(user.role);
    }
    // Otherwise show the item to everyone
    return true;
  });

  return (
    <div className="flex h-full w-64 flex-col bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-r">
      <div className="flex h-16 items-center px-6 border-b">
        <span className="text-xl font-bold">HOC+ Contracts</span>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-4">
        {filteredNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              cn(
                'flex items-center px-3 py-2 text-sm font-medium rounded-md',
                'transition-colors hover:bg-accent hover:text-accent-foreground',
                isActive ? 'bg-accent text-accent-foreground' : 'text-muted-foreground'
              )
            }
          >
            <item.icon className="mr-3 h-5 w-5" />
            {item.name}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}